/* c8 ignore start */
import { i18n } from "@/i18n.js";
import { SIDENAV_GROUP_BY } from "@/constants";
import { SAT_SERVICE } from "@/utils/services";
import { useFlag } from "@/composables/useFlags/useFlag";

const { isFeatureAvailable } = useFlag("SAT_CONTENT_MANAGER");
const { isFeatureAvailable: isSatCustomerReportManagerAvi } = useFlag(
  "SAT_CUSTOMER_REPORT_MANAGER",
);

const MSP_NAV_ITEMS = [
  {
    order: 2,
    groupBy: SIDENAV_GROUP_BY.BETA,
    label: i18n.global.t("sidebar-security-awareness-training"),
    name: "msp-security_awareness_training",
    icon: "cl-icon-tabler-school",
    id: "/msp/security_awareness_training",
    dataTestId: "msp-security_awareness_training",
    solutionId: SAT_SERVICE,
    children: [
      {
        label: i18n.global.t("sidebar-overview"),
        id: "/msp/security_awareness_training/overview",
        dataTestId: "msp-security_awareness_training-overview",
      },
      {
        label: i18n.global.t("sidebar-sat-campaigns"),
        id: "/msp/security_awareness_training/sat_campaigns",
        dataTestId: "msp-security_awareness_training-sat_campaigns",
      },
    ],
  },
];

export { MSP_NAV_ITEMS };

const CUSTOMER_NAV_ITEMS = [
  {
    order: 2,
    groupBy: SIDENAV_GROUP_BY.BETA,
    label: i18n.global.t("sidebar-security-awareness-training"),
    icon: "cl-icon-tabler-school",
    id: "/customer/security_awareness_training",
    dataTestId: "customer-security_awareness_training",
    solutionId: SAT_SERVICE,
    children: [
      {
        label: i18n.global.t("sidebar-overview"),
        id: "/customer/security_awareness_training/overview",
        dataTestId: "customer-security_awareness_training-overview",
      },
      {
        label: i18n.global.t("sidebar-sat-campaigns"),
        id: "/customer/security_awareness_training/sat_campaigns",
        dataTestId: "customer-security_awareness_training-sat_campaigns",
      },
    ],
  },
];

if (isFeatureAvailable.value) {
  CUSTOMER_NAV_ITEMS[0].children.push({
    label: i18n.global.t("sidebar-content-manager"),
    id: "/customer/security_awareness_training/content_manager",
    dataTestId: "customer-security_awareness_training-content_manager",
  });
}

if (isSatCustomerReportManagerAvi.value) {
  CUSTOMER_NAV_ITEMS[0].children.push({
    label: "Report Manager",
    id: "/customer/security_awareness_training/report_manager",
    dataTestId: "customer-security_awareness_training-report_manager",
  });
}

export { CUSTOMER_NAV_ITEMS };

/* c8 ignore end */
